import { DEFAULT_CUSTOMER_TYPE } from '@features/invoices/constants/defaultCustomerType'
import { PredefinedCustomerValues } from '@features/invoices/types/predefinedCustomerValues'

export const getCustomerFormDefaultValues = (predefinedCustomerValues?: PredefinedCustomerValues) => {
  const { customerType, ...customerValues } = predefinedCustomerValues || {}

  return {
    customerType: customerType ?? DEFAULT_CUSTOMER_TYPE,
    ...customerValues,
  }
}
